import { render, staticRenderFns } from "./FrameworksBar.vue?vue&type=template&id=2f40780a&scoped=true&"
import script from "./FrameworksBar.vue?vue&type=script&lang=ts&"
export * from "./FrameworksBar.vue?vue&type=script&lang=ts&"
import style0 from "./FrameworksBar.vue?vue&type=style&index=0&id=2f40780a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40780a",
  null
  
)

export default component.exports